import { FC, ReactElement } from "react";

export const StudentAfterSchool: FC = (): ReactElement => (
  <>
    <div className="cabinet__pannel">
      <div className="cabinet__title__wrapper">
        <h1 className="cabinet__title">After School</h1>
      </div>
    </div>
  </>
)
